/** Device performance classification for feature optimization */
export enum DevicePerformanceLevel {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}
